<template>
  <b-overlay :show="isUpload" rounded="sm">
    <div class="justify-content-md-center p-3 d-flex flex-column justify-content-between h-100"
      :style="userData.isAndroid ? '' : 'overflow-y: scroll;'">
      <div>
        <!-- Card Infomation -->
        <div class="pt-3" id="card-infomation">
          <span class="text-ktb-regular text-grey"
            style="line-height: 1.2 !important; display: block">กรุณาเตรียมเอกสารให้ครบถ้วนก่อนดำเนินการ
            หากคุณปิดหน้านี้
            เอกสารของคุณจะไม่ถูกบันทึก</span>
          <b-card class="border-radius-1rem mt-3" body-class="pt-2 pb-3 px-3">
            <b-row cols="2" class="mt-1 pt-1">
              <b-col class="text-left text-ktb-regular text-align-self-end" cols="5">
                <span style="line-height: 24px; vertical-align: baseline">หมายเลขใบสมัคร</span>
              </b-col>
              <b-col class="text-right text-ktb-bold-16 px-0" cols="7" style="padding-right: 15px !important">
                <span class="text-ktb-bold-16" style="line-height: 24px; vertical-align: baseline">{{ userData.loanAppId
                  }}</span></b-col>
            </b-row>
            <b-row cols="2" class="mt-1" style="line-height: 24px">
              <b-col class="text-left text-ktb-regular text-align-self-end px-0" style="
                  padding-left: 15px !important ;
                  line-height: 24px;
                  vertical-align: baseline;
                " cols="5">
                <span style="line-height: 24px; vertical-align: baseline">อัปโหลดภายในวันที่</span>
              </b-col>
              <b-col class="text-right text-ktb-bold-16" cols="7">
                <span class="text-ktb-bold-16" style="line-height: 24px; vertical-align: baseline">{{
    userData.expiredDate }}</span></b-col>
            </b-row>
            <b-row cols="2">
              <b-col class="text-left" cols="6"> </b-col>
              <b-col class="text-right text-ktb-regular-16 status-color-002">
                <span>อีก {{ userData.expireDay }} วัน</span></b-col>
            </b-row>
          </b-card>
        </div>
        <!-- Document Required -->
        <div class="mt-3" id="card-document-list" v-if="getDocumentGroupNoDeviate().length > 0">
          <div class="mb-2">
            <span class="text-ktb-bold-16">เอกสารประกอบการสมัคร</span>
          </div>

          <div class="mb-3 justify-content-md-center" v-for="(item, key) in getDocumentGroupNoDeviate()" :key="key">
            <b-card class="border-radius-1rem" body-class="body-landing py-3"
              @click="goToDocumentGroup(item.grp_id, item.state)">
              <b-row>
                <b-col cols="1" align-self="start">
                  <template v-if="item.state == 'attachfile'">
                    <b-img center :src="iconUploadated" width="24" height="24"></b-img>
                  </template>
                  <template v-else-if="item.state == 'success'">
                    <b-img center :src="iconUploadsSuccess" width="24" height="24"></b-img>
                  </template>
                  <template v-else-if="item.state == 'error'">
                    <b-img center :src="iconUploadsError" width="24" height="24"></b-img>
                  </template>
                  <template v-else-if="item.state == 'uploading' && item.progress > 0">
                    <b-img center :src="iconUploading" width="24" height="24"></b-img>
                  </template>
                  <template v-else-if="item.state == 'uploading'">
                    <b-img center :src="iconUploading" width="24" height="24"></b-img>
                  </template>
                  <template v-else>
                    <b-badge pill variant="primary" class="badge-wait"><span class="" style="line-height: 15px">
                        {{ key + 1 }}
                      </span></b-badge>
                  </template>
                </b-col>
                <b-col class="px-4 text-left" col>
                  <b-row>
                    <b-col col>
                      <span class="text-ktb-regular-16">{{
    item.grp_name
  }}</span>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="1" class="px-0">
                  <b-img v-if="item.state != 'success'" width="24" height="24" style="cursor: pointer"
                    :src="imgArrowRight"></b-img>
                  <b-img v-else width="24" height="24" style="cursor: none" :src="imgArrowNone"></b-img>
                </b-col>
                <template v-if="item.errorMsg && item.state == 'error'">
                  <div class="w-100">
                    <div class="px-3">
                      <hr />
                    </div>
                  </div>
                  <b-col><span class="px-3 text-danger py-1">{{
    item.errorMsg
  }}</span></b-col>
                </template>
                <template v-if="item.state == 'wait' &&
    'RESUBMIT' === userData.followupStatus.code
    ">
                  <div class="w-100 border-top-NEXT my-3 mx-3" />
                  <b-col><span class="text-resubmit py-1">{{
    "ขอเอกสารเพิ่มเติม"
  }}</span></b-col>
                </template>
              </b-row>
              <div v-if="item.progress > 0" class="mt-2">
                <b-progress class="progress-bar-custom" v-if="item.progress > 0" :value="item.progress"
                  max="100"></b-progress>
              </div>
            </b-card>
          </div>
        </div>
        <!-- Document Deviate -->
        <div class="mt-3" id="card-document-deviate-list" v-if="getDocumentGroupDeviate().length > 0 &&
    checkDisplayGroupDeviateLength()
    ">
          <div class="mb-2">
            <span class="text-ktb-bold-16">เอกสารเพิ่มเติม</span>
          </div>
          <div class="mb-3 justify-content-md-center" v-for="(item, key) in getDocumentGroupDeviate()" :key="key">
            <b-card v-if="checkDisplayGroupDeviate(item)" class="border-radius-1rem" body-class="body-landing py-3"
              @click="goToDocumentGroup(item.grp_id, item.state)">
              <b-row align-content="center">
                <b-col cols="1" align-self="start">
                  <template v-if="item.state == 'attachfile'">
                    <b-img center :src="iconUploadated" width="24" height="24"></b-img>
                  </template>
                  <template v-else-if="item.state == 'success'">
                    <b-img center :src="iconUploadsSuccess" width="24" height="24"></b-img>
                  </template>
                  <template v-else-if="item.state == 'error'">
                    <b-img center :src="iconUploadsError" width="24" height="24"></b-img>
                  </template>
                  <template v-else-if="item.state == 'uploading' && item.progress > 0">
                    <b-img center :src="iconUploading" width="24" height="24"></b-img>
                  </template>
                  <template v-else-if="item.state == 'uploading'">
                    <b-img center :src="iconUploading" width="24" height="24"></b-img>
                  </template>
                  <template v-else>
                    <b-badge pill variant="primary" class="badge-wait"><span class="text-center"
                        style="line-height: 15px">
                        {{ key + 1 + getDocumentGroupNoDeviate().length }}
                      </span></b-badge>
                  </template>
                </b-col>
                <b-col class="px-4 text-left" col>
                  <b-row>
                    <b-col col>
                      <span class="text-ktb-regular-16">{{
    item.grp_name
  }}</span>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="1" class="px-0">
                  <b-img v-if="item.state != 'success'" width="24" height="24" style="cursor: pointer"
                    :src="imgArrowRight"></b-img>
                  <b-img v-else width="24" height="24" style="cursor: none" :src="imgArrowNone"></b-img>
                </b-col>
                <template v-if="item.errorMsg && item.state == 'error'">
                  <div class="w-100 border-top-NEXT my-3" />
                  <b-col><span class="px-3 text-danger py-1">{{
    item.errorMsg
  }}</span></b-col>
                </template>
                <template v-if="item.state == 'wait' &&
    'RESUBMIT' === userData.followupStatus.code
    ">
                  <div class="w-100 border-top-NEXT my-3 mx-3" />
                  <b-col><span class="text-resubmit py-1">{{
    "ขอเอกสารเพิ่มเติม"
  }}</span></b-col>
                </template>
              </b-row>
              <div v-if="item.progress > 0" class="mt-2">
                <b-progress class="progress-bar-custom" v-if="item.progress > 0" :value="item.progress"
                  max="100"></b-progress>
              </div>
            </b-card>
          </div>
        </div>
      </div>
      <!-- Btn action -->
      <div>
        <div v-if="showSubmited()">
          <b-row class="mt-4" v-if="updateRender">
            <b-col>
              <button @click="doSubmit()" :class="'btn btn-info btn-block btn-ktb-' +
    userData.channel +
    (isUpload ? ' btn-loading' : '')
    " type="button" style="line-height: 20px" :disabled="!validateState()">
                <span v-if="isUpload">กำลังอัปโหลดเอกสาร</span>
                <span v-else-if="firstSubmit()">อัปโหลดเอกสาร</span>
                <span v-else>อัปโหลดอีกครั้ง</span>
              </button>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <b-modal id="bv-modal-error" v-model="modalShow" hide-header hide-header-close hide-footer
      content-class="modal-content-custom">
      <div class="justify-content-center text-center">
        <b-row class="justify-content-md-center">
          <b-col class="py-4"><span class="text-ktb-bold-20">{{
    errorDialogHeader
              }}</span></b-col>
          <div class="w-100" />
          <b-col>
            <b-img-lazy :src="errorDialogImage" width="240" height="168" center></b-img-lazy></b-col>

          <div class="w-100 py-2" />

          <b-col><span class="text-ktb-bold-20">{{ errorDialogTitle }}</span></b-col>
          <div class="w-100 py-2" />
          <b-col class="text-ktb-regular-16-grey">{{
            errorDialogMessage
            }}</b-col>
          <div class="w-100" style="margin-top: 95%" />
          <b-col>
            <button :class="'btn btn-info rounded-pill btn-block font-weight-bold btn-ktb btn-ktb-gradient btn-ktb-' +
    userData.channel
    " type="button" style="line-height: 20px" @click="$bvModal.hide('bv-modal-error')">
              <b style="color: white">ตกลง</b>
            </button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </b-overlay>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      imgExpire: require("@/assets/images/foundationIllustrationContextualVayuApplicationFail@3x.png"),
      imgSwalErr: require("@/assets/images/foundationIllustrationGenericError@3x.png"),
      imgArrowRight: require("@/assets/images/foundationIconSimpleSystemArrowRight@3x.png"),
      iconUploadsError: require("@/assets/images/foundationIconSimpleObjectStatusesFailed.png"),
      iconUploadsSuccess: require("@/assets/images/foundationIconSimpleComponentSnackbarUploadSuccessGreen.png"),
      iconUploading: require("@/assets/images/foundationIconSimpleComponentSnackbarUpload.png"),
      iconUploadated: require("@/assets/images/foundationIconSimpleComponentSnackbarSuccessBlue.png"),
      imgArrowNone: require("@/assets/images/foundationIconSimpleSystemArrowRight.png"),
      documentGroup: {},
      axiosInstance: null,
      timeout: parseInt(process.env.VUE_APP_TIMEOUT),
      maxsize: parseInt(process.env.VUE_APP_MAXSIZE),
      user: {},
      isUpload: false,
      updateRender: 1,
      countDocTypeUploading: 0,
      countDocTypeAttachfile: 0,
      urlapi: process.env.VUE_APP_APIURL,
      groupRequire: [],
      groupDeviate: [],
      docList: [],
      modalShow: false,
      errorDialogTitle: "",
      errorDialogMessage: "",
      errorDialogHeader: "",
      errorDialogImage: null,
  
    };
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    getHeight() {
      return window.innerHeight - 45;
    },
  },
  created() {
    try {
      this.$callback.enterFullScreen();
      this.$callback.gaTagging({
        action: GA_ACTIONS.VIEW,
        category: "DGLSelfApplyDocumentUpload",
        label: ""
      },
        [
          {
            key: 38,
            value: PRODUCT_TYPE.SMART_MONEY
          }

        ]);
    } catch (err) {
      //console.error(err);
    }
    let currentMenu = {
      pageCode: "CommonLanding",
      pageName: "อัปโหลดเอกสาร",
      previousPage: "",
    };
    this.$event.$emit("update_current_menu", currentMenu);
    this.documentGroup = this.userData.document_group_type;
    this.documentType = this.userData.documentType;
    for (let item of this.documentGroup) {
      if (item.state == "wait" || item.state == "addDocument") {
        item.state = this.setStateGroupDocument(item.grp_id);
      }
      if (
        item.grp_id === "01" &&
        item.state != "success" &&
        item.state != "error"
      ) {
        item.state = this.setStateGroupDocument(item.grp_id);
      }
      if (item.lst_doc_id.length > 1) {
        this.checkStateDocumentGroup(item)
      }

    }
    const fnSet = this.setIsLoading;
    this.axiosInstance = axios.create({
      baseURL: this.urlapi,
      timeout: this.timeout,
      headers: { Authorization: this.userData.uuid },
    });
    this.axiosInstance.interceptors.request.use(
      function (config) {
        fnSet(true);
        return config;
      },
      function (error) {
        fnSet(false);
        // Do  something with request error
        return Promise.reject(error);
      }
    );
    this.axiosInstance.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        fnSet(false);
        return Promise.reject(error);
      }
    );

    this.mappingGroup();
  },
  methods: {
    mappingGroup() {
      this.documentGroup.filter((item) => {
        let found = false;
        item.lst_doc_id.forEach((d) => {
          const data = this.documentType.find(
            (e) => e.doc_code == d && !e.deviate_flag
          );
          if (data !== undefined) found = true;
        });
        if (found) {
          this.groupRequire.push(item);
        } else {
          this.groupDeviate.push(item);
        }
      });
    },
    setIsLoading(value) {
      this.isUpload = value;
    },
    getDocumentGroup() {
      return this.documentGroup;
    },
    getDocumentType() {
      return this.documentType;
    },
    getDocumentGroupNoDeviate() {
      return this.groupRequire;
    },
    getDocumentGroupDeviate() {
      return this.groupDeviate;
    },
    getDocumentTypeIsRequire() {
      return this.documentType.filter((item) => !item.deviate_flag);
    },
    getDocumentTypeIsDeviate() {
      return this.documentType.filter((item) => item.deviate_flag);
    },
    checkDocTypeIsSuccess(grpId, state) {
      if (this.firstSubmit()) return false;
      if ("01" === grpId && state !== "error") {
        let attachfile = this.checkDocument(grpId);
        let dStatement =
          this.userData.dStatementSelected != undefined &&
          this.userData.dStatementSelected;
        let ktbStatement =
          this.userData.accountSelected != undefined &&
          this.userData.accountSelected != "";

        if (attachfile || dStatement || ktbStatement) {
          return true;
        } else {
          return false;
        }
      }

      return state === "success";
    },
    goToDocumentGroup(grpId, state) {
      //check success
      if (this.checkDocTypeIsSuccess(grpId, state)) return false;
      this.userData.grpId = grpId;
      this.$store.dispatch("setUserData", this.userData);
      let docList = [];
      this.listDoc = this.userData.document_group_type.find(
        (v) => v.grp_id == grpId
      );

      for (var i = 0; i < this.listDoc.lst_doc_id.length; i++) {
        for (var j = 0; j < this.userData.documentType.length; j++) {
          if (
            this.userData.documentType[j].doc_code == this.listDoc.lst_doc_id[i]
          ) {
            docList.push(this.userData.documentType[j]);
          }
        }
      }
      if (process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT == grpId) {
        this.$router.push({
          name: this.userData.routerPath.documentGroup,
          params: { grpId: grpId, action: "NEXT" },
        });
      } else if (docList.length == 1 && docList[0].state != "deviate") {
        this.goToUploadPage(docList[0].doc_code, grpId);
      } else {
        this.$router.push({
          name: this.userData.routerPath.documentGroup,
          params: { grpId: grpId, action: "NEXT" },
        });
      }
    },
    logout() {
      sessionStorage.clear();
      this.$store.dispatch("clearUserData");
      this.$router.push({
        name: this.userData.routerPath.login,
      });
    },
    showSubmited() {
      return ["PENDING", "SUBMITED", "RESUBMIT"].includes(
        this.userData.followupStatus.code
      );
    },
    checkDocument(grpId) {
      let docGroup = this.userData.document_group_type.find(
        (v) => v.grp_id == grpId
      );
      return (
        this.userData.documentType.filter(
          (docType) =>
            docGroup.lst_doc_id.includes(docType.doc_code) &&
            docType.filesReal.length > 0
        ).length > 0
      );
    },
    setStateGroupDocument(grp_id) {
      let state;
      if (this.checkDocument(grp_id)) {
        state = "attachfile";
      } else {
        state = "wait";
      }
      if ("01" === grp_id) {
        let attachfile = this.checkDocument(grp_id);
        let dStatement =
          this.userData.dStatementSelected != undefined &&
          this.userData.dStatementSelected;
        let ktbStatement =
          this.userData.accountSelected != undefined &&
          this.userData.accountSelected != "";

        if (attachfile || dStatement || ktbStatement) {
          state = "attachfile";
        } else {
          state = "wait";
        }
      }
      return state;
    },
    async doSubmit() {
      try {
        if (this.validateState()) {
          this.checkTimeOut().then(() => {
            if (this.$swal.isVisible()) return;
            this.doSubmitImageProcessing();
          });
        } else {
          this.getAlert("2001");
        }
      } catch (err) {
        console.error(err);
        this.getAlert("9999");
      }
    },
    firstSubmit() {
      let success = this.documentGroup.filter((i) => i.state == "success");
      let error = this.documentGroup.filter((i) => i.state == "error");
      return success.length == 0 && error.length == 0;
    },
    validateState() {
      //return false = disabled
      //return true = not disabled
      if (this.documentGroup.filter((i) => i.state == "error").length > 0)
        return false;
      let attachfileRequire = this.getDocumentType().filter(
        (i) => i.state == "attachfile" && !i.deviate_flag
      );
      let checkStatement = 0;
      if (this.firstSubmit()) {
        for (let item of this.documentGroup) {
          if (item.grp_id === "01") {
            let docCode = item.lst_doc_id[0];
            let docType = this.getDocumentType().find(
              (v) => v.doc_code == docCode
            );
            if (
              ((this.userData.dStatementSelected != undefined &&
                this.userData.dStatementSelected) ||
                (this.userData.accountSelected != undefined &&
                  this.userData.accountSelected != "")) &&
              (docType.filesReal == 0 || docType.filesReal === undefined)
            ) {
              checkStatement = 1;
              break;
            }
          }
        }
        if (
          attachfileRequire.length <
          this.getDocumentTypeIsRequire().length - checkStatement
        ) {
          return false;
        }
      } else {
        let attachfileRequireSecondSubmit = this.getDocumentType().filter(
          (i) => !i.deviate_flag
        ).length;
        let countSuccess = this.getDocumentTypeIsRequire().filter(
          (i) => i.state == "success"
        ).length;
        let document_group_type = this.userData.document_group_type.find(
          (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
        );
        if (document_group_type !== undefined) {
          let docCode = document_group_type.lst_doc_id[0];
          let docType = this.userData.documentType.find(
            (v) => v.doc_code == docCode
          );
          if (
            ((this.userData.dStatementSelected != undefined &&
              this.userData.dStatementSelected) ||
              (this.userData.accountSelected != undefined &&
                this.userData.accountSelected != "")) &&
            (docType.filesReal == 0 || docType.filesReal === undefined)
          ) {
            checkStatement = 1;
          }
        }
        if (checkStatement == 1) {
          if (attachfileRequireSecondSubmit > countSuccess + checkStatement) {
            return false;
          }
        } else {
          if (
            attachfileRequireSecondSubmit >
            countSuccess + attachfileRequire.length
          ) {
            return false;
          }
        }
      }

      return true;
    },
    async doSubmitImageProcessing() {
      let uploaded = false;
      this.updateRender += 1;
      this.countDocTypeUploading = 0;
      this.countDocTypeAttachfile = 0;
      this.documentGroup
        .filter((i) => i.state == "attachfile")
        .forEach((item) => {
          this.$set(item, "state", "uploading");
        });
      this.countDocTypeUploading = this.userData.documentType.filter(
        (docType) => docType.state == "attachfile"
      ).length;
      this.countDocTypeAttachfile = this.userData.documentType.filter(
        (docType) => docType.state == "wait"
      ).length;
      const totalDocDeviate = this.userData.documentType.filter(
        (docType) => docType.deviate_flag
      ).length;
      this.$forceUpdate();
      try {
        for (
          let docGroupItem = 0;
          docGroupItem < this.userData.document_group_type.length;
          docGroupItem++
        ) {
          if (
            this.userData.document_group_type[docGroupItem].state == "uploading"
          ) {
            let array = this.userData.documentType.filter((docType) =>
              this.userData.document_group_type[
                docGroupItem
              ].lst_doc_id.includes(docType.doc_code)
            );

            this.userData.document_group_type[docGroupItem].progress =
              this.randomNumber();
            for (let docTypeItem of array) {
              if (
                docTypeItem.state == "attachfile" &&
                docTypeItem.filesReal.length > 0
              ) {
                uploaded = true;
                await this.doSendUploaded(docTypeItem);
              }
              if (
                this.userData.document_group_type[docGroupItem].progress < 90
              ) {
                this.userData.document_group_type[docGroupItem].progress =
                  this.userData.document_group_type[docGroupItem].progress +
                  this.randomNumber();
              }
            }
            this.userData.document_group_type[docGroupItem].progress = 100;
            await this.delay(500);
            this.userData.document_group_type[docGroupItem].progress = 0;

            this.$forceUpdate();
          }
        }
        // deviate all
        if (
          this.countDocTypeUploading == 0 &&
          this.countDocTypeAttachfile == totalDocDeviate &&
          !uploaded
        ) {
          this.documentGroup
            .filter((i) => i.state == "wait")
            .forEach((item) => {
              this.$set(item, "state", "success");
            });
          this.$forceUpdate();
          this.triggerSubmit();
          return;
        }
        if (
          this.countDocTypeUploading == 0 &&
          this.userData.documentType.length == 1 &&
          !uploaded &&
          this.checkKtbStatement()
        ) {
          this.documentGroup
            .filter((i) => i.state == "wait")
            .forEach((item) => {
              this.$set(item, "state", "success");
            });
          this.$forceUpdate();
          this.triggerSubmit();
          return;
        }
      } catch {
        this.getAlert("9999");
      }
    },
    async delay(time) {
      await new Promise((resolve) => setTimeout(resolve, time));
    },
    randomNumber: function () {
      return Math.floor(Math.random() * 30);
    },
    doSendUploaded(docTypeItem) {
      if (this.modalShow) return;
      this.sendUploadsImageProcessing(this.getFormData(docTypeItem))
        .then((res) => {
          this.countDocTypeUploading = this.countDocTypeUploading - 1;
          if (res.data.status == "SUCCESS") {
            docTypeItem.state = "success";
          } else if (res.data.status == "FAIL") {
            for (let item of docTypeItem.filesReal) {
              for (let err of res.data.errorDetail) {
                if (item.filename == err.fileName) {
                  if (err.errorCode == "5005") {
                    item.fileHavePassword = true;
                    item.fileCheckassword = null;
                    item.password = "";
                  }
                }
              }
            }
            docTypeItem.state = "error";
          } else {
            docTypeItem.state = "error";
          }
          this.$forceUpdate();
          if (this.countDocTypeUploading == 0) {
            this.triggerSubmit();
          }
        })
        .catch(() => {
          console.log("catch");
          docTypeItem.state = "error";
          this.forceStateDocumentGroup(docTypeItem.doc_code);
          this.$forceUpdate();
        });
    },
    getFormData(docTypeObject) {
      let formData = new FormData();
      let password = [];
      if (docTypeObject.filesReal !== undefined) {
        docTypeObject.filesReal.forEach((f) => {
          

          if (f.file !== undefined) {
            formData.append(f.type, f.file);
            
          }
          if (!f.fileHavePassword && f.password != undefined) {
            password.push(f.file.name + "|" + f.password);
          }
        });
      }
      
      formData.append("doc_code", docTypeObject.doc_code);
      if (password.length > 0) formData.append("lst_password", password);
      return formData;
    },
    getFormDeviateData() {
      let grp01 = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docIdStatement;
      if (grp01 !== undefined) {
        docIdStatement = grp01.lst_doc_id[0];
      }

      let lstDeviate = [];

      this.userData.documentType.forEach((i) => {
        if (
          i.deviate_flag &&
          (i.filesReal == undefined || i.filesReal.length == 0)
        ) {
          lstDeviate.push(i.doc_code);
          i.state = "deviate";
        }
        if (
          i.doc_code == docIdStatement &&
          (i.filesReal == undefined || i.filesReal.length == 0)
        ) {
          lstDeviate.push(i.doc_code);
          i.state = "success";
        }
      });

      this.$forceUpdate();
      return {
        lstDeviate: lstDeviate,
        accountLst:
          this.userData.accountSelected != undefined
            ? this.userData.accountSelected
            : [],
        dStatementFlag:
          this.userData.dStatementSelected != undefined
            ? this.userData.dStatementSelected
            : false,
        docIdStatement: docIdStatement,
      };
    },
    async checkTimeOut() {
      console.log("myAuth:", this.userData.cif);
      let response;
      response = await this.axiosInstance({
        method: "GET",
        url: "api/checkTimeout",
        timeout: this.timeout,
      })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          if (this.userData.channel == "WEB") {
            this.$store.dispatch("clearUserData");
          }
          this.handdleError(error);
          return response;
        });
      return response;
    },
    sendUploadsImageProcessing(formData) {
      if (this.$swal.isVisible()) return;
      let response = this.axiosInstance({
        method: "POST",
        url: "/api/save",
        data: formData,
        timeout: 600000,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          this.handdleError(error);
        });
      return response;
    },
    sendApiDelay() {
      let response = this.axiosInstance
        .get("https://reqres.in/api/users?delay=5")
        .then((x) => {
          console.log(x);
        })
        .catch((error) => error);
      return response;
    },
    async sendUploads(formData) {
      this.axiosInstance({
        method: "POST",
        url: "/api/upload",
        data: formData,
      })
        .then((res) => {
          if (res.data.status) {
            this.userData.followupStatus = res.data.followupStatus;
            this.$store.dispatch("setUserData", this.userData);
            this.closeWeb(res.data.callDocTum);
          } else {
            if (!res.data.showKtbStatement) {
              let grp01 = this.userData.document_group_type.find(
                (item) =>
                  item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
              );
              if (grp01 !== undefined) {
                this.userData.documentType.forEach((i) => {
                  if (i.doc_group_code == "01") {
                    i.state = "error";
                  }
                });
                this.documentGroup.forEach((i) => {
                  if (i.grp_id == "01") {
                    i.state = "error";
                  }
                });
              }
              this.getAlert("5009");
              this.userData.showKtbStatement = res.data.showKtbStatement;
              this.userData.accountSelected = undefined
            } else {
              this.getAlert(res.data.code);
            }
          }
        })
        .catch((error) => {
          this.handdleError(error);
        });
    },
    closeWeb(callDocTum) {
      let grp01 = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docIdStatement = "";
      if (grp01 !== undefined) {
        docIdStatement = grp01.lst_doc_id[0];
      }
      this.axiosInstance({
        method: "GET",
        url: process.env.VUE_APP_PATH_CLOSE_WEB,
        headers: {
          Authorization: this.userData.uuid,
        },
        params: {
          callDocTum: callDocTum,
          dStatementFlag:
            this.userData.dStatementSelected != undefined
              ? this.userData.dStatementSelected
              : false,
          docIdStatement: docIdStatement,
        },
      })
        .then((response) => {
          const fn = this.setIsLoading;
          if ("Y" == response.data) {
            this.userData.followupStatus = {
              code: "COMPLETE",
              desc: "Pending for Approval",
              name: "คำขออยู่ระหว่างการพิจารณา",
            };
            this.$store.dispatch("setUserData", this.userData);
            this.$forceUpdate();
          }
          this.setIsLoading(true);
          setTimeout(function () {
            fn(false);
          }, 10000);
        })
        .catch((error) => {
          this.handdleError(error);
        });
    },
    handdleError(error) {
      console.log(error);
      this.$forceUpdate();
      this.setIsLoading(false);
      if (error.response) {
        if (
          error.response.data != undefined &&
          error.response.data.code != undefined
        ) {
          this.getAlert(error.response.data.code);
        } else {
          this.getAlert(error.response.status);
        }
      } else if (
        error.message !== undefined &&
        error.message.startsWith("timeout")
      ) {
        this.getAlert("5008");
      } else {
        this.getAlert("9999");
      }
    },
    getAlert(code) {
      this.updateRender += 1;
      this.setIsLoading(false);
      let title = null;
      let detail = null;
      let appIsExpired = false;
      let exitEntryPoint = false;
      switch (code) {
        case "2001":
          (title = "จำนวนเอกสารไม่ครบเงื่อนไขในการสมัคร"),
            (detail = "กรุณาตรวจสอบเอกสารประกอบการสมัครอีกครั้ง");
          break;
        case "4001":
          title = "ท่านทำรายการไม่ถูกต้อง";
          detail = "กรุณาทำรายการใหม่อีกครั้ง";
          break;
        case "4005":
          title = "Token Invalid";
          detail = "กรุณาเข้าสู่ระบบใหม่อีกครั้ง";
          break;
        case "4006":
          title = "หมดเวลาทำรายการ";
          detail = "กรุณาลองใหม่อีกครั้ง";
          exitEntryPoint = true;
          break;
        case "4007":
          title = "ข้อเสนอนี้หมดอายุแล้ว";
          detail =
            "คุณสามารถสมัครขอสินเชื่อได้อีกครั้ง เมื่อได้รับข้อเสนอจากธนาคาร";
          appIsExpired = true;
          break;
        case "4009":
          title = "หมดเวลาทำรายการ";
          detail = "กรุณาลองใหม่อีกครั้ง";
          exitEntryPoint = true;
          break;
        case "5003":
          (title = "ประเภทของไฟล์ไม่ถูกต้อง"),
            (detail = "กรุณาเลือกประเภทของไฟล์ได้แก่ PDF, PNG หรือ JPG");
          break;
        case "5004":
          (title = "ไฟล์มีปัญหา"),
            (detail = "ไม่สามารถเปิดไฟล์ได้ กรุณาลองใหม่อีกครั้ง");
          exitEntryPoint = true;
          break;
        case "5007":
          title = "ไม่สามารถดำเนินการได้ในขณะนี้";
          detail = "กรุณาลองใหม่อีกครั้ง";
          exitEntryPoint = true;
          break;
        case "5008":
          title = "ไม่สามารถดำเนินการได้ในขณะนี้";
          detail = "กรุณาลองใหม่อีกครั้ง(1)";
          exitEntryPoint = true;
          break;
        case "5009":
          title = "ระบบขัดข้อง";
          detail = "กำลังอยู่ระหว่างการแก้ไข ขออภัยในความไม่สะดวก กรุณากลับมาใหม่อีกครั้ง(1)";
          exitEntryPoint = true;
          break;
        default:
          title = "ระบบขัดข้อง";
          detail =
            "กำลังอยู่ระหว่างการแก้ไข ขออภัยในความไม่สะดวก กรุณากลับมาใหม่อีกครั้ง";
          exitEntryPoint = true;
      }
      if (appIsExpired) {
        this.offerExpire(title, detail);
      } else if (exitEntryPoint) {
        if (this.userData.isAndroid) {
          this.showAlertThenExitEntryPointAndroid(
            this.imgSwalErr,
            title,
            detail
          );
        } else {
          this.showAlertThenExitEntryPointIOS(this.imgSwalErr, title, detail);
        }
      } else {
        this.swalError(title, detail);
      }
    },
    offerExpire(title, detail) {
      // if (this.modalShow) return;
      // this.modalShow = true;
      // this.errorDialogTitle = title;
      // this.errorDialogHeader = "สถานะการสมัคร";
      // this.errorDialogMessage = detail;
      // this.errorDialogImage = this.imgExpire;
      // this.$forceUpdate();
      if (this.userData.isAndroid) {
        this.showAlertThenExitEntryPointAndroid(this.imgExpire, title, detail);
      } else {
        this.showAlertThenExitEntryPointIOS(this.imgExpire, title, detail);
      }

      this.$callback.gaTagging({
        action: GA_ACTIONS.VIEW,
        category: "DGLSelfApplyAppStatusDt_Failed",
        label: ""
      },
        [
          {
            key: 38,
            value: PRODUCT_TYPE.SMART_MONEY
          }

        ]);
    },
    swalError(title, detail) {
      // if (this.modalShow) return;
      // this.modalShow = true;
      // this.errorDialogTitle = title;
      // this.errorDialogHeader = "อัปโหลดเอกสาร";
      // this.errorDialogMessage = detail;
      // this.errorDialogImage = this.imgSwalErr;
      // this.$forceUpdate();
      this.showAlert(this.imgSwalErr, title, detail);
    },
    showAlert(img, title, msg) {
      if (this.$swal.isVisible()) return;
      this.$swal
        .fire({
          imageUrl: img,
          position: "bottom",
          title: title,
          text: msg,
          width: 300,
          padding: "1em",
          confirmButtonText: "ตกลง",
          confirmButtonColor: "#00A3E4",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          customClass: {
            title: "text-ktb-bold-16 dstatement-popup",
            confirmButton:
              "btn rounded-pill btn-block font-weight-bold btn-ktb-NEXT swal-button-info btn-padding",
            popup: "swal2-modal-dstatement",
            image: "swal2-image-dstatement",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.documentGroup
              .filter((i) => i.state == "uploading")
              .forEach((item) => {
                this.$set(item, "state", "attachfile");
              });
            this.$forceUpdate();
          }
        });
    },
    showAlertThenExitEntryPointIOS(img, title, msg) {
      if (this.$swal.isVisible()) return;
      this.$swal
        .fire({
          iconHtml: "อัปโหลดเอกสาร",
          imageUrl: img,
          position: "center",
          title: title,
          text: msg,
          confirmButtonText: "ตกลง",
          confirmButtonColor: "#00A3E4",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          customClass: {
            title: "text-ktb-bold-20 dstatement-popup",
            confirmButton:
              "btn rounded-pill btn-block font-weight-bold btn-ktb-NEXT swal-button-info btn-padding swal2-button-next-fullscreen",
            popup: "swal2-modal-dstatement swal2-modal-next-fullscreen",
            image: "swal2-image-dstatement swal2-image-next-fullscreen",
            htmlContainer:
              "swal2-htmlContainer-next-fullscreen text-ktb-regular-16-grey",
            actions: "swal2-actions-next-fullscreen",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.documentGroup
              .filter((i) => i.state == "uploading")
              .forEach((item) => {
                this.$set(item, "state", "attachfile");
              });
            this.$forceUpdate();

            if (title == "ข้อเสนอนี้หมดอายุแล้ว") {
              this.$callback.gaTagging({
                action: GA_ACTIONS.CLICK,
                category: "DGLSelfApplyAppStatusDt_Failed",
                label: "DGLSelfApplyAppStatusDt_Failed_Done"
              },
                [
                  {
                    key: 38,
                    value: PRODUCT_TYPE.SMART_MONEY
                  }

                ]);
            }
            try {
              this.$callback.exitEntryPoint();
            } catch (err) {
              console.error(err);
            }
          }
        });
    },
    showAlertThenExitEntryPointAndroid(img, title, msg) {
      if (this.$swal.isVisible()) return;
      this.$swal
        .fire({
          iconHtml: "อัปโหลดเอกสาร",
          imageUrl: img,
          position: "bottom",
          title: title,
          text: msg,
          confirmButtonText: "ตกลง",
          confirmButtonColor: "#00A3E4",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          customClass: {
            title: "text-ktb-bold-16 dstatement-popup",
            confirmButton:
              "btn rounded-pill btn-block font-weight-bold btn-ktb-NEXT swal-button-info btn-padding",
            popup: "swal2-modal-dstatement",
            image: "swal2-image-dstatement",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {


            if (title == "ข้อเสนอนี้หมดอายุแล้ว") {
              this.$callback.gaTagging({
                action: GA_ACTIONS.CLICK,
                category: "DGLSelfApplyAppStatusDt_Failed",
                label: "DGLSelfApplyAppStatusDt_Failed_Done"
              },
                [
                  {
                    key: 38,
                    value: PRODUCT_TYPE.SMART_MONEY
                  }

                ]);
            }


            try {
              this.$callback.exitEntryPoint();
            } catch (err) {
              console.error(err);
            }
          }
        });
    },
    triggerSubmit() {
      try {
        this.setStateDocumentGroup();
        this.setIsLoading(false);
        if (
          this.getDocumentGroup().filter((d) => d.state == "error").length > 0
        )
          return;
        let data = this.getFormDeviateData();
        this.sendUploads(data);
      } catch (err) {
        console.error(err);
      }
    },
    setStateDocumentGroup() {
      let arrayGroup = this.documentGroup.filter((i) => i.state == "uploading");
      arrayGroup.forEach((docGroup) => {
        let array = this.userData.documentType.filter(
          (docType) =>
            docGroup.lst_doc_id.includes(docType.doc_code) &&
            docType.state == "error"
        );
        if (array.length == 0) {
          docGroup.state = "success";
        } else {
          docGroup.state = "error";
          docGroup.errorMsg = "อัปโหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง";
        }
      });
      this.$forceUpdate();
    },
    forceStateDocumentGroup(docCode) {
      let arrayGroup = this.documentGroup.filter(
        (i) => i.state == "uploading" && i.lst_doc_id.includes(docCode)
      );
      arrayGroup.forEach((docGroup) => {
        let array = this.userData.documentType.filter(
          (docType) =>
            docGroup.lst_doc_id.includes(docType.doc_code) &&
            docType.state == "error"
        );
        if (array.length == 0) {
          docGroup.state = "success";
        } else {
          docGroup.state = "error";
          docGroup.errorMsg = "อัปโหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง";
        }
      });
      this.$forceUpdate();
    },
    checkDisplayGroupDeviate(item) {
      if (this.firstSubmit()) return true;
      if (
        item.state == "success" ||
        item.state == "error" ||
        item.state == "attachfile"
      )
        return true;
      return false;
    },
    checkDisplayGroupDeviateLength() {
      let count = 0;
      if (this.firstSubmit()) return true;
      this.getDocumentGroupDeviate().forEach((item) => {
        if (
          item.state == "success" ||
          item.state == "error" ||
          item.state == "attachfile"
        )
          count++;
      });
      return count > 0;
    },
    goToUploadPage(doc_code, grpId) {
      this.$router.push({
        name: this.userData.routerPath.upload,
        params: { doc_code: doc_code, grpId: grpId },
      });
    },
    checkKtbStatement() {
      let grp01 = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );

      let docIdStatement;
      if (grp01 !== undefined) {
        docIdStatement = grp01.lst_doc_id[0];
        return (
          docIdStatement !== undefined &&
          (this.userData.accountSelected != undefined ||
            this.userData.dStatementSelected != undefined)
        );
      } else {
        return false;
      }
    },
    calcHeight() {
      var h = window.innerHeight;
      return h < 680;
    },
    checkStateDocumentGroup(documentGroup) {
      console.log(documentGroup);
      let attachComplete = true;
      documentGroup.lst_doc_id.forEach((d) => {
        const data = this.documentType.find(
          (e) => e.doc_code == d && !e.deviate_flag
        );
        if (data !== undefined && data.filesReal != undefined && data.filesReal.length == 0) {
          attachComplete = false;
        }
      });
      documentGroup.state = attachComplete ? 'attachfile' : 'wait';

    }

  },
};
</script>
<style scoped>
.row-card-landing {
  padding-left: 14px;
  padding-right: 14px;
}

.body-landing {
  padding-left: 1rem;
  padding-right: 1rem;
}

.progress-bar-custom {
  height: 3px;
  border-radius: unset;
  border-bottom-left-radius: 60px 27px;
  border-bottom-right-radius: 60px 27px;
  margin-left: 2.5px;
  margin-right: 2.5px;
  background-color: unset;
}

.status-color-001 {
  color: #479e6a !important;
}

.status-color-002 {
  color: #df0747 !important;
}

.status-color-003,
.status-color-004 {
  color: #daa60b !important;
}

.status-color-PENDING,
.status-color-RESUBMIT {
  color: #df0747 !important;
}

.status-color-SUBMITED,
.status-color-SUBMITED2,
.status-color-COMPLETE {
  color: #479e6a !important;
}

.badge-primary {
  border: 1.5px solid #33c5ff;
  box-sizing: border-box;
  position: absolute;
  margin: -10px -10px;
  margin-top: 0rem;
  color: #33c5ff;
  background-color: transparent;
  width: 24px;
  height: 24px;
}

.badge-wait {
  border: 1.5px solid #c2d0d9 !important;
  box-sizing: border-box;
  position: absolute;
  margin: -10px -10px;
  margin-top: 0rem;
  color: #c2d0d9 !important;
  background-color: transparent;
  width: 24px;
  height: 24px;
  margin-left: 1%;
}

.text-danger {
  color: rgb(219, 0, 0);
  font-family: KrungthaiFast-Regular, Arial, sans-serif !important;
  font-size: 16px !important;
}

.text-resubmit {
  color: rgb(212, 150, 74);
  font-family: KrungthaiFast-Regular, Arial, sans-serif !important;
  font-size: 16px !important;
}
</style>
<style>
.text-loan-info {
  color: black !important;
  font-family: KrungthaiFast-Bold, Arial, sans-serif !important;
}

.text-label {
  color: #727a8d !important;
  font-size: 14px;
}

.position-footer {
  position: fixed;
  bottom: 0;
  margin-bottom: 10%;
}

.content-card-sm {
  min-height: 45vh;
}

.content-card-md {
  min-height: 55vh;
}

.btn-loading {
  color: rgb(145, 159, 169) !important;
  background-color: rgb(231, 235, 240) !important;
  border-color: rgb(231, 235, 240) !important;
  background-image: none !important;
}

.swal2-htmlContainer-next-fullscreen {
  font-size: 16px !important;
  margin-bottom: 25vh !important;
  margin-top: 1rem !important;
  line-height: 24px !important;
  height: 50% !important;
}

.swal2-image-next-fullscreen {
  margin-top: 10vh !important;
  margin-bottom: 10vh !important;
}

.swal2-icon {
  border-color: unset !important;
  border: unset !important;
  line-height: 20px !important;
  width: 100% !important;
  margin: 0px !important;
  align-items: unset !important;
}

.swal2-icon-content {
  font-family: KrungthaiFast-Bold, Arial, sans-serif !important;
  color: black !important;
  font-size: 20px !important;
}

.swal2-modal-next-fullscreen {
  border-radius: 0px !important;
  width: 100% !important;
  padding: 24px !important;
  height: 100vh !important;
  -webkit-animation: unset !important;
  animation: unset !important;
}

.swal2-actions-next-fullscreen {
  display: flex !important;
  justify-content: center !important;
  margin-top: 1rem !important;
  margin-right: 0px !important;
  margin-bottom: 35px !important;
  margin-left: 0px !important;
}
</style>
